import { __decorate } from "tslib";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
let pageGap = class pageGap extends Vue {
  constructor() {
    super(...arguments);
    this.text = "";
  }
  dataChage(value) {
    this.text = value.text;
    console.log(this.text, "图片预览组件---", value);
  }
};
__decorate([Prop({
  type: Object,
  default: {}
})], pageGap.prototype, "item", void 0);
__decorate([Watch("item", {
  immediate: true,
  deep: true
})], pageGap.prototype, "dataChage", null);
pageGap = __decorate([Component({
  name: "s"
})], pageGap);
export default pageGap;